import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { CanActivate, CanActivateChild } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { UrlParamsState } from './url-params.state';
import { selectUrlParams } from './url-params.selector';
import 'rxjs/add/operator/take';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/switchMap';

/**
 * Guards are hooks into the route resolution process, providing an opportunity
 * to inform the router's navigation process whether the route should continue
 * to activate this route. Guards must return an observable of true or false.
 */
@Injectable()
export class UrlParamsGuard implements CanActivate, CanActivateChild {
    constructor(
        private store: Store<UrlParamsState>) { }

    /**
     * This method creates an observable that waits for the `params` property
     * of the collection state to turn defined, emitting one time once loading
     * has finished.
     */
    waitForAccessToken(): Observable<boolean> {
        return this.store.select(selectUrlParams)
            .filter(params => !!(params  &&  params.access_token))
            .map(params => !!params)
            .take(1);
    }


    /**
     * This is the actual method the router will call when our guard is run.
     */
    canActivate(): Observable<boolean> {
        return this.waitForAccessToken();
    }


    canActivateChild(): Observable<boolean> {
        return this.canActivate();
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/url-params/url-params.guard.ts